import React from 'react';
import { SpeedInfoRow } from '../SpeedInfoRow';
import './style.scss';

export const SpeedInfoBlock = () => (
  <div className="speed">
    <SpeedInfoRow title="Gigabytes" percent={20} />
    <SpeedInfoRow title="100 mbsp" percent={85} />
    <SpeedInfoRow title="1 mbsp" percent={45} />
    <div className="speed_metric">
      <div className="speed_metric_row">
        <div className="speed_metric_cell">0</div>
        <div className="speed_metric_cell">10</div>
        <div className="speed_metric_cell">20</div>
        <div className="speed_metric_cell">30</div>
        <div className="speed_metric_cell">40</div>
        <div className="speed_metric_cell">50</div>
        <div className="speed_metric_cell">60</div>
        <div className="speed_metric_cell">70</div>
        <div className="speed_metric_cell">80</div>
        <div className="speed_metric_cell">90</div>
        <div className="speed_metric_cell">100</div>
      </div>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/view/screens/Project/components/SpeedInfoBlock/index.js